















    import Vue from 'vue';
    import Component from 'vue-class-component';

    @Component({
        components: {},
    })
    export default class Help extends Vue {
        private mounted() {
            // const pre = this.$refs.doc.querySelector('textarea');
            // this.$refs.doc.innerHTML = this.$parent.$parent.$parent.convertToHtml(pre.value)
            const value = `##### Markdown语法教程 (Markdown syntax tutorial)

- [Markdown Syntax](http://daringfireball.net/projects/markdown/syntax/ "Markdown Syntax")
- [Mastering Markdown](https://guides.github.com/features/mastering-markdown/ "Mastering Markdown")
- [Markdown Basics](https://help.github.com/articles/markdown-basics/ "Markdown Basics")
- [GitHub Flavored Markdown](https://help.github.com/articles/github-flavored-markdown/ "GitHub Flavored Markdown")
- [Markdown 语法说明（简体中文）](http://www.markdown.cn/ "Markdown 语法说明（简体中文）")
- [Markdown 語法說明（繁體中文）](http://markdown.tw/ "Markdown 語法說明（繁體中文）")

##### Emoji表情参考 (Emoji reference)

- [Github emoji](http://www.emoji-cheat-sheet.com/ "Github emoji")
- [Twitter Emoji \\(Twemoji\\)](http://twitter.github.io/twemoji/preview.html "Twitter Emoji \\(Twemoji\\)")
- [FontAwesome icons emoji](http://fortawesome.github.io/Font-Awesome/icons/ "FontAwesome icons emoji")

##### TeX/LaTeX reference

[http://meta.wikimedia.org/wiki/Help:Formula](http://meta.wikimedia.org/wiki/Help:Formula)

                        `;
            (this.$refs.doc as any).innerHTML = (this.$parent.$parent.$parent as any).convertToHtml(value);
        }
    }
